"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "YAKAP_FPE_V0", {
    enumerable: true,
    get: function() {
        return YAKAP_FPE_V0;
    }
});
/*
 * yakap-fpe-v0: a PROVISIONAL placeholder for the PhilHealth YAKAP First
 * Patient Encounter form. PhilHealth's official field list is pending from the
 * client. When it arrives, add it as a new descriptor (for example
 * `yakap-fpe-v1`) and bump CURRENT_FPE_FORM_VERSION. Never edit this one: it
 * is released, and stored records were captured on it (ADR-0020).
 */ // PENDING official YAKAP field list (HLX-82 A1)
const CONDITION_OPTIONS = [
    {
        value: 'none',
        label: 'None known'
    },
    {
        value: 'hypertension',
        label: 'Hypertension'
    },
    {
        value: 'diabetes',
        label: 'Diabetes'
    },
    {
        value: 'asthma',
        label: 'Asthma'
    },
    {
        value: 'tuberculosis',
        label: 'Tuberculosis'
    },
    {
        value: 'heartDisease',
        label: 'Heart disease'
    },
    {
        value: 'cancer',
        label: 'Cancer'
    },
    {
        value: 'kidneyDisease',
        label: 'Kidney disease'
    },
    {
        value: 'other',
        label: 'Other'
    }
];
const YAKAP_FPE_V0 = {
    formVersion: 'yakap-fpe-v0',
    title: 'YAKAP First Patient Encounter',
    provisional: true,
    requiredVitals: [
        'bp',
        'weightKg',
        'heightCm'
    ],
    sections: [
        {
            key: 'yakap.membership',
            title: 'PhilHealth membership',
            fields: [
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'membershipCategory',
                    label: 'Membership category',
                    kind: 'select',
                    required: true,
                    options: [
                        {
                            value: 'member',
                            label: 'Member'
                        },
                        {
                            value: 'dependent',
                            label: 'Dependent'
                        },
                        {
                            value: 'indigent',
                            label: 'Indigent'
                        },
                        {
                            value: 'seniorCitizen',
                            label: 'Senior citizen'
                        },
                        {
                            value: 'other',
                            label: 'Other'
                        }
                    ]
                }
            ]
        },
        {
            key: 'yakap.vitals',
            title: 'Vital signs',
            fields: [
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'vitals',
                    label: 'Vital signs',
                    kind: 'custom:vitals',
                    required: false
                }
            ]
        },
        {
            key: 'yakap.history',
            title: 'Medical history',
            fields: [
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'pastMedicalHistory',
                    label: 'Past medical history',
                    kind: 'multiselect',
                    required: true,
                    options: CONDITION_OPTIONS
                },
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'pastMedicalHistoryOther',
                    label: 'Other condition',
                    kind: 'text',
                    required: true,
                    maxLength: 200,
                    showIf: {
                        field: 'pastMedicalHistory',
                        equals: 'other'
                    }
                },
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'currentMedications',
                    label: 'Current medications',
                    kind: 'textarea',
                    required: false
                },
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'pastSurgeries',
                    label: 'Past surgeries',
                    kind: 'textarea',
                    required: false
                }
            ]
        },
        {
            key: 'yakap.family',
            title: 'Family history',
            fields: [
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'familyHistory',
                    label: 'Family history',
                    kind: 'multiselect',
                    required: false,
                    options: CONDITION_OPTIONS
                },
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'familyHistoryOther',
                    label: 'Other condition',
                    kind: 'text',
                    required: true,
                    maxLength: 200,
                    showIf: {
                        field: 'familyHistory',
                        equals: 'other'
                    }
                }
            ]
        },
        {
            key: 'yakap.social',
            title: 'Social history',
            fields: [
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'smoking',
                    label: 'Smoking',
                    kind: 'select',
                    required: true,
                    options: [
                        {
                            value: 'never',
                            label: 'Never'
                        },
                        {
                            value: 'former',
                            label: 'Former'
                        },
                        {
                            value: 'current',
                            label: 'Current'
                        }
                    ]
                },
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'alcohol',
                    label: 'Alcohol',
                    kind: 'select',
                    required: true,
                    options: [
                        {
                            value: 'none',
                            label: 'None'
                        },
                        {
                            value: 'occasional',
                            label: 'Occasional'
                        },
                        {
                            value: 'regular',
                            label: 'Regular'
                        }
                    ]
                },
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'physicalActivity',
                    label: 'Physical activity',
                    kind: 'select',
                    required: true,
                    options: [
                        {
                            value: 'sedentary',
                            label: 'Sedentary'
                        },
                        {
                            value: 'moderate',
                            label: 'Moderate'
                        },
                        {
                            value: 'active',
                            label: 'Active'
                        }
                    ]
                }
            ]
        },
        {
            key: 'yakap.screening',
            title: 'Risk screening',
            fields: [
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'riskFactors',
                    label: 'Risk factors',
                    kind: 'multiselect',
                    required: false,
                    options: [
                        {
                            value: 'obesity',
                            label: 'Obesity'
                        },
                        {
                            value: 'highBloodPressure',
                            label: 'High blood pressure'
                        },
                        {
                            value: 'highBloodSugar',
                            label: 'High blood sugar'
                        },
                        {
                            value: 'smoking',
                            label: 'Smoking'
                        },
                        {
                            value: 'unhealthyDiet',
                            label: 'Unhealthy diet'
                        },
                        {
                            value: 'physicalInactivity',
                            label: 'Physical inactivity'
                        }
                    ]
                },
                // PENDING official YAKAP field list (HLX-82 A1)
                {
                    key: 'notes',
                    label: 'Screening notes',
                    kind: 'textarea',
                    required: false
                }
            ]
        }
    ]
};
